import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

interface Coach {
  coach_id: string
  coach_email: string
  coach_first_name: string
  coach_last_name: string
  relationship_created_at: string
}

export function useAthleteCoach(athleteId?: string) {
  const [coach, setCoach] = useState<Coach | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!athleteId) {
      setLoading(false)
      return
    }

    const fetchCoach = async () => {
      try {
        setLoading(true)
        const { data, error } = await supabase.rpc('get_athlete_coaches', {
          target_athlete_id: athleteId,
        })

        if (error) {
          throw error
        }

        // Get the first coach (assuming one coach per athlete for now)
        if (data && data.length > 0) {
          setCoach(data[0])
        } else {
          setCoach(null)
        }
      } catch (err) {
        console.error('Error fetching coach:', err)
        setError(err as Error)
      } finally {
        setLoading(false)
      }
    }

    fetchCoach()
  }, [athleteId])

  return { coach, loading, error }
}
